module.exports = __webpack_public_path__ + "static/img/category-banner.90fee22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/category-banner.jpg
// module id = sfSU
// module chunks = 1